module.exports = __webpack_public_path__ + "static/media/logo-lemedia.7512ce93.svg";